<template>
    <div>
        <v-row>
            <v-col cols="12" sm="12">
                <v-checkbox color="primary" v-model="estimate.isPdr" label="Is PDR?" />
                <v-text-field v-if="estimate.isPdr" v-model="estimate.pdrAmount" label="PDR Amount" />
                <v-checkbox color="primary" v-model="estimate.isAlloys" label="Is Alloys?" />
                <v-text-field v-if="estimate.isAlloys" v-model="estimate.alloysAmount" label="Alloys Amount" />
                <v-checkbox v-if="estimate.isAlloys" v-model="estimate.alloyTypes" value="PC" color="primary" label="PC" />
                <v-checkbox v-if="estimate.isAlloys" v-model="estimate.alloyTypes" value="DC" color="primary" label="DC" />
                <v-checkbox v-if="estimate.isAlloys" v-model="estimate.alloyTypes" value="CCH" color="primary" label="CCH" />
                <v-checkbox v-if="estimate.isAlloys" v-model="estimate.alloyTypes" value="CR" color="primary" label="CR"></v-checkbox>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "EstimateContractors",
        props: {
            estimate: Object
        }
    }
</script>

<style scoped>

</style>
